export const PagesTitle = ({ title }) => {
    return (
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-xl sm:text-xl">{ title }</span>
            </div>
            <hr />
        </div>
    )
}